'use client';

// Bootstrap css
import '../../styles/libraryStyleOverrides/bootstrap.scss';

// Timeline
import 'react-vertical-timeline-component/style.min.css';

// Fontawesome icons (add all at once vs. individually)
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

// Overrides

// TODO: move some of these into the bootstrap overrides as variables
import '../../styles/libraryStyleOverrides/Button.scss';
import '../../styles/libraryStyleOverrides/Input.scss';

// Other global styles
import './global.scss';

export function GlobalStyles() {
	return null;
}
